export default {
  getSwapDialog(state) {
    return state.swapDialog;
  },
  getSwapTokenSymbol(state) {
    return state.swapTokenSymbol;
  },
  getTokenBalText(state) {
    return state.tokenBalText;
  },
  getTokenReserves(state) {
    return state.tokenReserves;
  },
};
